import { InventoryLocationDto } from "../models"
import { ACTION_TYPES } from "./types"

export const Action = {
    fetchListing: () => {
        return {
            type: ACTION_TYPES.FETCH_LISTING,
        }
    },

    fetchListingSuccess: (locations: InventoryLocationDto[]) => {
        return {
            type: ACTION_TYPES.FETCH_LISTING_SUCCESS,
            payload: locations,
        }
    },

    submit: () => {
        return {
            type: ACTION_TYPES.SUBMIT,
        }
    },

    setStockInventoryName: (name: string) => {
        return{ 
            type: ACTION_TYPES.SET_NAME,
            payload: name
        }
    },

    setLocation: (locationIds: string[]) => {
        return {
            type: ACTION_TYPES.SET_LOCATION_IDS,
            payload: locationIds
        }
    },

    setFromListing: (listingId: string) => {
        return {
            type: ACTION_TYPES.SET_FROM_LISTING,
            payload: listingId
        }
    },
    
    submitSuccess: () => {
        return {
            type: ACTION_TYPES.SUBMIT_SUCCESS
        }
    },

    submitFail: (errorMessage: string) => {
        return{
            type: ACTION_TYPES.SUBMIT_FAIL,
            payload: errorMessage
        }
    },

    clearLocation: () => {
        return {
            type: ACTION_TYPES.CLEAR_LOCATION,
        }
    },

    delete: () => {
        return {
            type: ACTION_TYPES.DELETE,
        }
    },

    deleteSuccess: () => {
        return {
            type: ACTION_TYPES.DELETE_SUCCESS,
        }
    },

    deleteFail: (errorMessage: string) => {
        return{
            type: ACTION_TYPES.DELETE_FAIL,
            payload: errorMessage
        }
    },

    setInventoryLocation: (inventoryLocation: InventoryLocationDto) => {
        return {
            type: ACTION_TYPES.SET_INVENTORY_LOCATION,
            payload: inventoryLocation
        }
    },
}






// WEBPACK FOOTER //
// ./src/state/inventory/location/actions/actions.ts